import styled from 'styled-components'

export const GetInTouchDiv = styled.div`
min-height: 400px;
background: #FFFFFF;
display:flex;
flex-direction:row;


.roww{
    display:flex;
    flex-direction:row;
    justify-content:center;
    width:100%;
}

.firstdiv{
    display:flex;
    flex-direction:column;
    text-align:start;
    width:50%;
    margin-right:100px;

    h2{
        font-family: Gilroy;
        font-style: normal;
        font-weight: bold;
        font-size: 45px;
        line-height: 56px;
        color: #000000;
    }
    p{
        font-family: Gilroy;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.7);
    }
}

.seconddiv{
    display:flex;
    width:30%;
    flex-direction:column;
   

    input{
        margin:6px;
        background: rgba(229, 229, 229, 0.4);
        border-radius: 6px;
        border:none;
        border-style:hidden;
        :focus{
            box-shadow: none;
        }
        
    }
    .lastinput{
        padding:40px;
        display:flex;
        text-align:start;
        justify-content:start;
    }
}

.but{
    /* width:330px; */
    background: #1DCDFE;
    border-radius: 6px;
    margin:6px 0px 6px 10px;
    border:none;
    border-style:hidden;
    :focus{
        box-shadow: none;
    }
}

svg{
    margin-right:10px;
    :hover{
        
    }
}
@media (max-width:700px){
    .firstdiv{
        width:100%;
        margin-top:270px;
    }
    .seconddiv{
        width:100%;
    }
}

`